import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';


const lenderNameLengthMin = 3;
const lenderNameLengthMax = 50;
const lenderNameLengthMaxEntry = 50;
const Lienholder = props => (
  <BaseInput
    name="lienHolder"
    label="Your bank's name"
    type="text"
    autoComplete="off"
    transparent
    maxLength={ lenderNameLengthMaxEntry.toString() }
    validate={val =>
      string()
        .required("Your bank's name")
        .min(lenderNameLengthMin, `Your bank's name must be greater than ${lenderNameLengthMin - 1} characters`)
        .max(lenderNameLengthMax, `Your bank's name cannot be greater than ${lenderNameLengthMax} characters`)
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

Lienholder.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string
};

Lienholder.defaultProps = {
  value: '',
  error: ''
};

export default Lienholder;
